// extracted by mini-css-extract-plugin
export default {"main":"Projects_main__173WK","level1":"Projects_level1__exdzH","Projects":"Projects_Projects__33+Md","tech":"Projects_tech__vhNZ9","show":"Projects_show__AddN7"};